import { defer } from '@/components/utils/defer';
import { createLogger } from '@/lib/logger';

const logger = createLogger('plp-segmentation-tiles');

function injectSegmentationTiles(targetSelector: string) {
  const insertLocationElem = document.querySelector(targetSelector);

  if (!insertLocationElem) {
    logger.error('Insert location not found');
    return;
  }

  const insertLocation: InsertPosition = (window.theme.plpSegmentationTiles?.injectionLocation ??
    'afterend') as InsertPosition;

  const segmentationTilesTemplate = document.querySelector<HTMLTemplateElement>(
    '#plp-segmentation-tiles-template',
  );

  if (!segmentationTilesTemplate) {
    logger.error('Segmentation tiles template not found');
    return;
  }

  // Clone document fragment from template into the target location, using insertLocation as the parent
  const segmentationTilesContent = segmentationTilesTemplate.innerHTML;

  insertLocationElem.insertAdjacentHTML(insertLocation, segmentationTilesContent);
}

function initSwiper() {
  const swiper = new window.Swiper('.segmentation-tiles--wrapper.swiper', {
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 12,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      1280: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const segmentationTilesExist = document.querySelector('.segmentation-tiles--wrapper.swiper');
  const loadingFinishedSelector = '.boost-sd__header-title';

  let targetSelector =
    window?.theme?.plpSegmentationTiles?.injectionLocationSelector ??
    '.boost-sd__collection-header';

  if (segmentationTilesExist) {
    logger.info('Segmentation tiles already exist. Exiting early');
    return;
  }

  defer(() => {
    try {
      injectSegmentationTiles(targetSelector);
      initSwiper();
    } catch (error) {
      logger.error('Error inserting segmentation tiles', error);
    }
  }, loadingFinishedSelector);
});
